<template>
  <footer class="page_footer py-4">
    <div class="container mt-2">
      <div class="row align-items-center">
        <div class="col-3">
          <a href="/" class="logo">
            <img
              class="img-fluid"
              src="./../assets/img/logo.svg"
              alt="4k-soft"
            />
          </a>
        </div>

        <div class="col-9 d-none d-lg-block">
          <div class="row g-0 menu py-4 py-lg-0">
            <div class="col-12 d-flex">
              <div
                class="flex-column flex-lg-row row g-0 w-100 align-items-center justify-content-between justify-content-lg-center"
              >
                <div class="col-12 col-lg-8">
                  <nav class="page_header_nav d-none d-lg-block">
                    <ul
                      class="d-lg-flex align-items-center justify-content-center main_menu list-unstyled m-0"
                    >
                      <li class="main_menu__item text-center text-lg-left">
                        <a
                          class="text-decoration-none px-4 py-3 py-lg-2 d-block"
                          href="#main"
                          >Main
                        </a>
                      </li>
                      <li class="main_menu__item text-center text-lg-left">
                        <a
                          class="text-decoration-none py-3 px-4 py-lg-2 d-block"
                          href="#how-it-works"
                          >How it works?
                        </a>
                      </li>
                      <li class="main_menu__item text-center text-lg-left">
                        <a
                          class="text-decoration-none px-4 py-3 py-lg-2 d-block"
                          href="#ai-solution"
                        >
                          AI Solutions
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div class="col-6 col-lg-4">
                  <div
                    class="d-flex justify-content-center justify-content-lg-end"
                  >
                    <a class="btn btn-primary" @click="signUpAndOpenModal"
                      >Log In</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-8 col-lg-4 d-flex justify-content-end d-lg-none ms-auto"
        >
          <div class="d-flex justify-content-center justify-content-lg-end">
            <a class="px-4 px-md-5 btn btn-primary">Log In</a>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-5">
        <p>© Copyright 2023 4K-SOFT.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterHomePage",
  data() {
    return { showModal: false };
  },
  methods: {
    signUpAndOpenModal() {
      this.$emit("openModal");
    },
  },
};
</script>

<style scoped lang="scss"></style>
